export default __webpack_public_path__ + "static/media/kh-dog.160439ae.svg";